import {CanActivate, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';
import {ApplicationPropertiesService} from '@synisys/idm-application-properties-service-client-js';
import {map} from 'rxjs/operators';
import {Feature} from '../enum/feature.enum';

@Injectable()
export class RegistrationAvailabilityGuard implements CanActivate {

	constructor(
		private readonly router: Router,
		private readonly applicationPropertiesService: ApplicationPropertiesService) {
	}

	public canActivate(): Observable<boolean> | Promise<boolean> | boolean {
		return Observable.fromPromise(this.applicationPropertiesService.isFeatureEnabled(Feature.REGISTRATION_DISABLED))
			.pipe(
				map(enabled => {
					if (enabled) {
						this.router.navigate(['/login']);
						return false;
					}
					return true;
				})
			);
	}
}
